// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23Dpj","placeholdersHeader":"styles_placeholdersHeader__Lxl2U","editorStyle":"styles_editorStyle__Lrkgs","placeholdersBox":"styles_placeholdersBox__3WISd"};